import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
var MatureAgeBlockedOverlay = function (_a) {
    var deviation = _a.deviation, overrideMatureFilter = _a.overrideMatureFilter, props = __rest(_a, ["deviation", "overrideMatureFilter"]);
    var t = useTranslation().t;
    var deviationType = getDeviationType(deviation);
    var isTier = deviationType === DeviationTypes.TIER;
    var matureTiers = useFlag('mature_tiers');
    return (React.createElement(HiddenLayout, __assign({ deviation: deviation, icon: React.createElement(Hidden, null), title: matureTiers && isTier && !props.compact
            ? t('deviationview.tier.blocked.mature.underage')
            : t('deviationview.blocked.mature.underage'), text: matureTiers && isTier
            ? t('deviationview.tier.blocked.mature.underage.text')
            : t('deviationview.blocked.mature.underage.text'), button: React.createElement(Button, { view: "b14", height: matureTiers && isTier && props.compact
                ? 'small'
                : 'medium', onClick: overrideMatureFilter }, matureTiers && isTier && props.compact
            ? t('deviationview.blocked.displayTier')
            : t('deviationview.blocked.displayAnyway')) }, props)));
};
MatureAgeBlockedOverlay.displayName = 'MatureAgeBlockedOverlay';
export default MatureAgeBlockedOverlay;
//# sourceMappingURL=MatureAgeBlocked.js.map